var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90018 15.0197L7.99962 15.9995L9.09907 15.0197C12.6099 11.8909 14.3996 9.1116 14.3996 6.51C14.3996 2.81647 11.5651 0 7.99962 0C4.43414 0 1.59961 2.81647 1.59961 6.51C1.59961 9.1116 3.38937 11.8909 6.90018 15.0197ZM7.99951 2.13334C10.3898 2.13334 12.2662 3.99774 12.2662 6.51C12.2662 8.29095 10.8817 10.5034 7.99951 13.1383C5.11737 10.5034 3.73284 8.29095 3.73284 6.51C3.73284 3.99774 5.6092 2.13334 7.99951 2.13334ZM7.99951 3.20001C9.76683 3.20001 11.1995 4.6327 11.1995 6.40001C11.1995 8.16733 9.76683 9.60002 7.99951 9.60002C6.2322 9.60002 4.7995 8.16733 4.7995 6.40001C4.7995 4.6327 6.2322 3.20001 7.99951 3.20001ZM6.93295 6.40001C6.93295 5.81091 7.41052 5.33334 7.99962 5.33334C8.58873 5.33334 9.06629 5.81091 9.06629 6.40001C9.06629 6.98912 8.58873 7.46668 7.99962 7.46668C7.41052 7.46668 6.93295 6.98912 6.93295 6.40001Z",
    fill: "#284FAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic-location.4895efcddd2f22632c12de3a792bef83.svg";
export { ForwardRef as ReactComponent };